module.exports = __webpack_public_path__ + "img/right-corner.89a40d97.svg";